module.exports = __webpack_public_path__ + "h5/img/hongka_footer.b7f96322.png";